import styled from 'styled-components';

import { List } from 'components/list';

export const StyledList = styled(List)`
  flex: 1;
`;
